import { useMemo, useState } from 'react';
import { useGetLmsDashboardStatisticsQuery } from '../../../../api';

export const ALL_TIME = 'all';

const useLmsDashboardStats = () => {
    const currentYear = new Date().getFullYear();
    const [period, setPeriod] = useState(currentYear);

    const { data, isLoading, isFetching } = useGetLmsDashboardStatisticsQuery(period === ALL_TIME ? {} : { year: period });

    const years = useMemo(() => [currentYear, currentYear - 1, currentYear - 2], [currentYear]);

    return { stats: data, isLoading: isLoading || isFetching, period, setPeriod, years, currentYear };
};

export default useLmsDashboardStats;
